module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/step2-pict01-71ff542eb0efe8428c28b53ee297d9b7.jpg";